/*
 * Performance Optimizations for CLS and INP
 * - Prevents layout shifts from images without dimensions
 * - Defers non-critical work via requestIdleCallback
 * - Suppresses harmless ResizeObserver loop errors
 * - Yields to the main thread during long tasks to improve INP
 */

/* ===== ResizeObserver Loop Error Suppression ===== */
(function suppressResizeObserverErrors() {
  window.addEventListener('error', function(e) {
    if (e.message && e.message.indexOf('ResizeObserver loop') !== -1) {
      e.stopImmediatePropagation();
    }
  }, true);
})();

/* ===== CLS: Aspect Ratio for Images ===== */
(function fixImageCLS() {
  function processImages() {
    var images = document.querySelectorAll('img[width][height]:not([data-ar-set])');
    for (var i = 0; i < images.length; i++) {
      var img = images[i];
      if (img.closest('[style*="aspect-ratio"]')) continue;
      var w = parseInt(img.getAttribute('width'), 10);
      var h = parseInt(img.getAttribute('height'), 10);
      if (w > 0 && h > 0 && !img.style.aspectRatio) {
        img.style.aspectRatio = w + ' / ' + h;
        img.setAttribute('data-ar-set', '1');
      }
    }
  }

  /* Run once on load, then observe new images via a lightweight MutationObserver */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processImages);
  } else {
    processImages();
  }

  if ('MutationObserver' in window) {
    var debounceTimer;
    new MutationObserver(function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(processImages, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* ===== INP: Yield to main thread helper ===== */
window.yieldToMain = function() {
  return new Promise(function(resolve) {
    if ('scheduler' in window && 'yield' in window.scheduler) {
      window.scheduler.yield().then(resolve);
    } else {
      setTimeout(resolve, 0);
    }
  });
};

/* ===== Emit ready event ===== */
document.dispatchEvent(new CustomEvent('performance:optimized', {
  detail: { timestamp: performance.now() }
}));
